<template>
    <div class="page-container">
      <div class="flex-between top">
        <div>
          <el-select v-model="value" placeholder="请选择" class="college-select">
            <el-option
              v-for="item in options"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
        </div>
      <div class="top-icons">
        <img :src="logo" alt="logo" >
        <el-popover placement="top-start" width="200" trigger="hover">
        <div class="flex-column-space-between ">
          <p class="password cp" @click="changePassword">修改密码<i class="el-icon-caret-right"></i></p>
          <p class="password cp"  style="margin-top: 20px;"@click="changeInfor">编辑资料<i class="el-icon-caret-right"></i></p>
          <p class="password cp" @click="quit" style="margin-top: 20px;">退出登录<i class="el-icon-caret-right"></i></p>
        </div>
          <img :src="av" alt="头像" slot="reference">
        </el-popover>
      </div>
      </div>
      
    <div class="flex-between top2">
      <h2 class="motto">笃学力行 守正求新</h2>
      <div class="search-container"> 
        <!-- <el-input v-model="input" placeholder="请输入学生学号" class="search-input"></el-input>
        <el-input v-model="input" placeholder="请输入学生姓名" class="search-input"></el-input>
        <el-button type="primary" icon="el-icon-search" class="search-btn">搜索</el-button> -->
      </div>
    </div>
      
      <div class="main-content">
        <div class="mainbox">
          <div class="left-section">

       <div class="box1left1" >
        <div style="display: flex;justify-content: space-between;align-items: center;">
    <p class="text">精准帮扶团队</p>
          <div>          <el-select v-model="selectedValue" placeholder="请选择" style="width: 130px;margin:0 auto;">
            <el-option
              v-for="item in options1"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select></div>
        </div>

    <!-- 这里是滚动区域的容器 -->
    <div 
        class="help-list-container"
        style="height: 77vh; overflow-y: auto; padding-right: 10px;" v-if="leftList.length>0">
        <!-- 遍历帮扶列表 -->
        <div 
         class="help-list-item"
            style="padding: 10px 0px 10px 15px; display: flex;" 
            v-for="(item, index) in leftList" 
            :key="index"
            
            >
            <img :src="url" alt="" @click="turnnTO(item)">
            <div class="flex-column-space-between cp" style="margin-left: 10px;" @click="turnnTO(item)">
                <p class="name">{{ item.userName }}</p>
                <p class="helptotal">帮扶中：{{ item.count1 }}</p>
            </div>

        </div>

    </div>
            <div v-else>
               <p style="margin: 0 auto; font-size: 20px;display: flex;justify-content: center;">暂时没有数据</p>
        </div>
</div>



          </div>
          <div class="middle-section">
            <!-- 中间 -->
              <div class="box1center">
                <p class="text">帮扶情况</p>
                  <div class="stats-container">
                  <!-- 第一个卡片 -->
                  <div class="stats-card" @click="personData">
                    <img :src="yello" alt="被帮扶申请" class="stats-icon">
                    <div class="stats-content">
                      <p class="stats-title">正在帮扶（人）</p>
                      <p class="stats-value">{{ count1 }}</p>
                    </div>
                  </div>
                  
                  <!-- 第二个卡片 -->

                     <div class="stats-card"  @click="personOver">
                    <img :src="blue" alt="全部学生" class="stats-icon">
                    <div class="stats-content">
                      <p class="stats-title">帮扶结束（人）</p>
                      <p class="stats-value">{{ count2 }}</p>
                    </div>
                  </div>

                </div>

            </div>
            <div class="right1 flex-column-between">


            <div class="right">
                <div class="flex-between">
                    <p class="text">帮扶课程</p>
                </div>
                <el-table
            :data="bottomsList"
             height="90%"

            style="width: 100%;font-size: 20px;"
            :default-sort = "{prop: 'date', order: 'descending'}"
            >
            <el-table-column prop="courseName" label="课程名称" fixed header-align="center" align="center"></el-table-column>
            <el-table-column prop="userName" label="教师名称" header-align="center" align="center">
                <template slot-scope="scope">
                  <span>
                    {{ scope.row.userName }}
                    <span v-if="scope.row.keyStudent === 1" > (骨干学生)</span>
                  </span>
                </template>
            </el-table-column>
            <el-table-column prop="count1" label="正在帮扶学生人数" header-align="center" align="center"></el-table-column>
            <el-table-column prop="count2" label="未达标人数" header-align="center" align="center"> </el-table-column>
            <el-table-column
              fixed="right"
              label="详情"
              header-align="center" align="center"
              >
              <template slot-scope="scope">
                    <el-button  size="small" class="butview" @click="turnTos(scope.row)">查看</el-button>
              </template>
            </el-table-column>
          </el-table>
            </div>
              <div class="floating-box">
                <div class="cur">
                  <el-pagination
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page="pageQueryDTO.curPage"
                    :page-sizes="arr"
                    :page-size="pageQueryDTO.pageSize"
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="count">
                  </el-pagination>
                </div>
              </div>
        </div>






          </div>

        </div>
        
      </div>
  
      <!-- 修改密码对话框 -->
        <el-dialog :visible.sync="dialogVisible" width="25%" custom-class="custom-dialog">
      <Password @custom-event="handleDataFromChild4"></Password>
    </el-dialog>
      
      <!-- 编辑资料对话框 -->
    <el-dialog :visible.sync="dialogVisible1" width="25%" custom-class="custom-dialog">
      <Information @custom-info="handleDataFromInfo4" :inform = "inform"></Information>
    </el-dialog>
    </div>
  </template>

<script>
import teamLeft from './compontents/teamLeft.vue'
import teamTop from './compontents/teamtop.vue'
import teamBottom from './compontents/teambottom.vue'
import Password from '@/components/Password/Password.vue'
import Information from '@/components/Information/Information.vue'
export default {
  components: {
    teamLeft,
    teamTop,
    teamBottom,
    Password,
    Information
  },
  data() {
    return {
      arr: [5, 12],
      count: 100,
       pageQueryDTO: {
        curPage: 1,
        pageSize: 12,
      },
      url: require('@/assets/pic/back.png'),
      logo: require('@/assets/pic/logo.png'),
      av: require('@/assets/pic/avatar.png'),
      red: require('@/assets/pic/red.png'),
      yello: require('@/assets/pic/yello.png'),
      green: require('@/assets/pic/green.png'),
      blue: require('@/assets/pic/blue.png'),
      count1:'',
      count2:'',
      input: '',
      inform:{},
      selectedValue:'2',
      options: [{
        value: '0',
        label: '电子信息学院'
      }],
            url: require('@/assets/pic/teamicon.png'),
      helpList:[

      ],
      options1: [
              {
        value: '1',
        label: '骨干学生'
      },
        {
        value: '2',
        label: '帮扶教师'
      },
      {
        value: '3',
        label: '帮扶导员'
      },

    ],
    leftList:[],
    dialogVisible:false,
    dialogVisible1:false,
    bottomsList:[],
      value: '0',
      select: ''
    }
  },
    watch: {
      selectedValue(selectedValue) {
        console.log('type:', selectedValue);
        this.selectedValue = selectedValue || ''
        this.feData()
      }
      },
  mounted(){
    this.feData()
    this.bottomList()
  },
  methods:{

    turnnTO(item){
      const selectedValue = this.selectedValue;
      console.log(item,'this.item')
              this.$router.push({
    path: '/courselist',
    query: { item: JSON.stringify(item)} // 将对象转为字符串传递
  });

    },
   async feData(){
                  try {
        const headers = { 'satoken': localStorage.getItem('token') };
        const params = {
          type:this.selectedValue
        }
        
        const res = await this.$http.get(
          `${this.$config.API_BASE_URL}/hz-university-pc/get_support_team`,
          { params, headers }
        );
        if (res.data.code === 200) {
          this.leftList = res.data.data || [];
         this.num()
          console.log(this.leftList,'this.leftList')
        }
      } catch (error) {
        console.error("加载数据失败", error);
      }
    },
    async num(){
           try {
    const headers = { 'satoken': localStorage.getItem('token') };

    // 正确的写法：headers 放到第三个参数
    const res = await this.$http.post(
      `${this.$config.API_BASE_URL}/hz-university-pc/get_support`,
      {},  // 请求体，这里如果没有数据传递则是一个空对象
      { headers }  // headers 应该放在第三个参数配置对象中
    );

    if (res.data.code === 200) {
      console.log(res.data.data, 'ddd');
      this.count1 = res.data.data.count1 || '0';
      this.count2 = res.data.data.count2 || '0';

    }
  } catch (error) {
    console.error("加载数据失败", error);
  }
    },
    async bottomList(){
          try {
        const headers = { 'satoken': localStorage.getItem('token') };
      const params = {
        pageQueryDTO: this.pageQueryDTO
      };
        const res = await this.$http.post(
          `${this.$config.API_BASE_URL}/hz-university-pc/get_support_courses`,params,
          {  headers }
        );
        if (res.data.code === 200) {
          this.bottomsList = res.data.data || [];
         this.count = res.data.totalRows;
          console.log(this.bottomsList,'this.bottomsList')
        }
      } catch (error) {
        console.error("加载数据失败", error);
      }
    },
    turnTos(item){
           
      const highlightRowId = {
          courseId: item.courseId,
          courseName: item.courseName,
          studentNumber: item.studentNumber,
          userName:item.userName
};
 console.log(item,'iitem')
  console.log(highlightRowId,'highlightRowIdhighlightRowId')
        this.$router.push({
    path: '/leaderlist',
    query: { highlightRowId } 
  });
    },
        handleSizeChange(val) {
      this.pageQueryDTO.pageSize = val;
      this.bottomList()
    },

    handleCurrentChange(val) {
      this.pageQueryDTO.curPage = val;
      this.bottomList()
    },

    handleSelectionChange(selection) {
      console.log('选中的行数据:', selection);
    },
         quit(){
          const headers = {
                'satoken': localStorage.getItem('token'),
              };
              this.$confirm('此操作退出登录, 是否继续?', '提示', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'warning'
            }).then(() => {
            this.$http.get(`${this.$config.API_BASE_URL}/hz-university-pc/user/logout`,{ headers }).then((resp) => {
            let data = resp.data;
            if(data.code == '200') {       						
                this.$router.push({path:'/'})
                 localStorage.clear();
            this.$message({
                type: 'success',
                message: '退出登录成功!'
              });
            } else {
              this.$message.error(data.msg);
    
            }
          }); 
            }).catch(() => {
              this.$message({
                type: 'info',
                message: '已取消退出登录'
              });          
            });
        },
            handleDataFromInfo4(data){
            console.log("父组件收到数据:", data); 
            const headers = {
              'satoken': localStorage.getItem('token'),
            };
            const mailbox = data.email;
            const datainfo = {
              mailbox:mailbox,
              phone:data.phone

            }

       this.$http.post(`${this.$config.API_BASE_URL}/hz-university-pc/user/updateUser`, datainfo, { headers }).then((resp) =>{
              let data = resp.data;
              console.log(data, 'data');
              if(data.code =='200'){

							this.$message({
								message: data.msg,
								type: 'success'
						});
								this.dialogVisible1 = false
						}else{
							this.$message.error(data.msg);
						}
            })
          .catch((error) => {
          console.error("数据请求失败", error);
        });
   
    },
               //修改密码
      handleDataFromChild4(data) {
      console.log("父组件收到数据:", data); 
      const headers = {
        'satoken': localStorage.getItem('token'),
      };
       this.$http.post(`${this.$config.API_BASE_URL}/hz-university-pc/user/updateUserPassWord`, data, { headers }).then((resp) =>{
              let data = resp.data;
              console.log(data, 'data');
              if(data.code =='200'){

							this.$message({
								message: data.msg,
								type: 'success'
						});
             this.dialogVisible = false
						
						}else{
							this.$message.error(data.msg);
						}
            })
          .catch((error) => {
          console.error("数据请求失败", error);
        });
    },
    changePassword(){
      this.dialogVisible = true
    },
            changeInfor(){
          this.dialogVisible1 = true
          const headers = {
        'satoken': localStorage.getItem('token'),
      };
       this.$http.get(`${this.$config.API_BASE_URL}/hz-university-pc/user/getOneUser`,  { headers }).then((resp) =>{
              let data = resp.data;
              console.log(data, 'data');
              if(data.code =='200'){
                this.inform = data.data
							this.$message({
								message: data.msg,
								type: 'success'
						});
						
						}else{
							this.$message.error(data.msg);
						}
            })
          .catch((error) => {
          console.error("数据请求失败", error);
        });
        },
    personData(){
      this.$router.push({path:'/peason'})
        
    },
        personOver(){
      this.$router.push({path:'/overperson'})
        
    }
  }
}
</script>

<style scoped>
  .password{
      width: 150px;
      height: 35px;
      opacity: 1;
      border-radius: 15px;
      border: 1px solid rgba(39, 154, 255, 1);
      margin: auto;

      font-size: 20px;
      font-weight: 500;
      letter-spacing: 0px;
      line-height: 28.96px;
      color: rgba(130, 127, 127, 1);
      text-align: center;
}
  .helllp{

font-size: 14px;
font-weight: 500;
letter-spacing: 0px;
line-height: 20.27px;
color: rgba(102, 102, 102, 0.8);


}
.les {
  font-size: 1rem;
  font-weight: 500;
  margin-bottom: 0.5rem;
}

/* 课程项 */
.course-item {
  gap: 0.625rem;
  margin-bottom: 3%;
}

.course-info {
  width: 80%;
  margin-left: 1%;
}
  .titlebg{
width: 450px;
height: 45px;
opacity: 0.5;
background: rgba(237, 243, 246, 1);
padding: 9px;
margin-bottom: 20px;
}
  .overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 100;
}

.dialog {
  position: fixed;
  top: 50%;
  transform: translateY(-50%);
  width: 495px;
  height: 80vh;
  background: white;
  padding: 20px;
  border-radius: 5px;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.3);
  z-index: 101;
    /* 新增滚动相关样式 */
  max-height: 80vh; /* 设置最大高度为视口的80% */
  overflow-y: auto; /* 垂直方向超出时显示滚动条 */
  display: flex;
  flex-direction: column; /* 确保内容垂直排列 */
}
.dialog1 {
  position: fixed;
  top: 50%;
  transform: translateY(-50%);
  width: 1026px;
    height: 80vh;
  background: white;
  padding: 20px;
  border-radius: 5px;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.3);
  z-index: 101;
      /* 新增滚动相关样式 */
  max-height: 80vh; /* 设置最大高度为视口的80% */
  overflow-y: auto; /* 垂直方向超出时显示滚动条 */
  display: flex;
  flex-direction: column; /* 确保内容垂直排列 */
}

.left-dialog {
  left: calc(50% - (495px + 1026px + 20px)/2);
}

.right-dialog {
  left: calc(50% - (495px + 1026px + 20px)/2 + 495px + 20px);
}
.close-icon {
  position: absolute;
  top: 15px;
  right: 20px;
  font-size: 24px;
  cursor: pointer;
  color: #999;
  transition: color 0.2s;
}

.close-icon:hover {
  color: #333;
}
  .rednum{
    width: 39px;
    height: 25px;
    opacity: 1;
    border-radius: 5px;
    background: rgba(229, 16, 19, 1);

    font-size: 16px;
    font-weight: 700;
    letter-spacing: 0px;
    line-height: 23.17px;
    color: rgba(255, 255, 255, 1);
    text-align: center;
    margin-top: 1%;



  }
  .rightbottom{
    width: 100%;
    position: relative; /* 父容器设为相对定位 */
    height: 63vh;
    background: #fff;
    padding: clamp(10px, 1.0vw, 20px);
    border-radius: 10px;
  

  }
.text{
    margin-top: 15px;
    font-size: 22px;
    font-weight: 500;
    letter-spacing: 0px;
    line-height: 31.86px;
    color: rgba(51, 51, 51, 1);
}
.college-select {
  width: 150px;
  /* height: 35px; */
}
.name{
    font-size: 18px;
    font-weight: 500;
    line-height: 26.06px;
    color: rgba(51, 51, 51, 1);
}
.helptotal{
    /** 文本1 */
    font-size: 16px;
    font-weight: 500;
    line-height: 23.17px;
    color: rgba(102, 102, 102, 0.8);
}
.helping{
    text-align: center;
    margin: auto;
    left: 245px;
    font-size: 15px;
    font-weight: 500;
    letter-spacing: 0px;
    line-height: 26.06px;
    color: rgba(67, 67, 67, 1);
}
  .buttext{
    position: absolute; /* 绝对定位 */
    left: 5%;        /* 距离左侧50px */
    top: 70%;    
    width: 30%;
    height: 20%;
    opacity: 1;

}
  .righttop{
    width: 100%;
    position: relative; /* 父容器设为相对定位 */
    height: 13vh;
    background-image: url('../../assets/pic/createbg.png');
    background-size:contain;
    border-radius: 10px;
    padding: 15px;
  }
  /* 基础重置与全局设置 */
  :root {
    font-size: 16px; /* 基准字体大小 */
  }
  
  * {
    box-sizing: border-box;
    margin: 0;
    padding: 0;
  }
  
  /* 响应式字体设置 */
  html {
    font-size: calc(14px + 0.3vw); /* 根据视口宽度动态调整 */
  }
  .line{
    width: 100%;
    height: 0px;
    opacity: 1;
    border: 1px solid rgba(224, 225, 242, 1);
  }
  /* 使用深度选择器穿透scoped样式 */
::v-deep .custom-dialog {
  border-radius: 30px;
  background: #fff;
  border: 2px solid #fff;
  overflow: hidden;
}
::v-deep .custom-dialog .el-dialog__header,
::v-deep .custom-dialog .el-dialog__body {
  background: transparent;
}
  /* 页面容器 */
  .page-container {
    background-image: url('../../assets/pic/background.png');
    background-size: cover;
    background-position: center;
    min-height: 100vh;
    padding: 0 clamp(10px, 2%, 20px); /* 响应式padding */
    display: flex;
    flex-direction: column;
  }
  
  /* 顶部栏优化 */
  .top {
    width: 100%;
    padding-top: clamp(10px, 2%, 20px);
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex-wrap: wrap; /* 小屏幕换行 */
    gap: 10px;
  }
  
  .top-icons img {
    width: clamp(30px, 3.5vw, 55px);
    height: clamp(30px, 3.5vw, 55px);
    margin-left: clamp(5px, 1vw, 15px);
  }
  
  .college-select {
    width: clamp(180px, 12vw, 220px);
  }
  
 /* 搜索区域 */
.top2 {
  width: 100%;
  /* padding: 1.25rem 6.25rem 0; */
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.motto {
  font-size: 1.5rem;
  font-weight: 700;
  color: #5ea5ff;
}

.search-container {
  display: flex;
  gap: 0.625rem;
}

.search-input {
  width: 18.75rem;
}

.search-btn {
  width: 5rem;
}

  /* 主要内容区域全面优化 */
  .main-content {
    width: 100%;
    padding: clamp(10px, 4%, 30px) 0 clamp(10px, 2%, 20px);
    flex: 1;
    min-height: 0;
  }
  
  .mainbox {
    width: 100%;
    height: 100%;
    display: flex;
    gap: clamp(8px, 1vw, 15px);
    min-height: 0;
  }
  
  .left-section {
    flex: 0.7;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    gap: clamp(8px, 1vw, 15px);
    min-height: 0;
  }
  
  .middle-section {
    flex: 3.1;
    min-height: 0;
    height: 64vh;
  }
  

  
  /* 卡片通用样式 */
  .box1left {
    width: 100%;
height: 22vh;
    border-radius: 10px;
    background: #fff;
    padding: clamp(8px, 1.0vw, 15px);

    display: flex;
    flex-direction: column;
    box-shadow: 0 2px 8px rgba(0,0,0,0.1);
  }
  .box1right1 {
    width: 100%;
height: 56vh;


    padding: clamp(5px, 0.5vw, 5px);
    display: flex;
    flex-direction: column;

  }
  .box1left3 {
    width: 100%;
height: 25vh;
    border-radius: 10px;
    background: #fff;
    padding: clamp(8px, 1vw, 15px);
    display: flex;
    flex-direction: column;
    box-shadow: 0 2px 8px rgba(0,0,0,0.1);
  }
  /* 通知区域 */
  .notice-content {
    flex: 1;
    overflow-y: auto;
    padding-right: 5px;
  }
  
  .notice-item, .notice-item1 {
    display: flex;
    align-items: center;
    margin-top: clamp(5px, 1vh, 15px);
  }
  
  .notice-text {
    margin-left: clamp(5px, 1vw, 15px);
  }
  
  /* 文字样式全面优化 */
  .text {
    font-size: clamp(1rem, 1.3vw, 1.5rem);
    font-weight: 500;
    color: #333;
    margin-bottom: clamp(5px, 1vh, 15px);
  }
  
  .tname {
    font-size: clamp(1.2rem, 1.8vw, 1.8rem);
    font-weight: 700;
    text-align: center;
    /* margin: clamp(5px, 2vh, 20px) 0; */
  }
  
  .les, .textleft {
    font-size: clamp(0.9rem, 1.1vw, 1.2rem);
    font-weight: 500;
    color: #333;
  }
  
  .textleftdown {
    font-size: clamp(0.7rem, 0.9vw, 0.9rem);
    color: rgba(102, 102, 102, 0.8);
  }
  
  .notice-time {
    font-size: clamp(0.6rem, 0.8vw, 0.8rem);
    color: #999;
  }
  
/* 修复后的关键样式 */
.box1left1 {
  height:77vh; /* 根据实际需要调整 */
  display: flex;
  flex-direction: column;
  padding: 15px;
  border-radius: 10px;
  background: #fff;
  /* gap: clamp(8px, 1vw, 15px); */
}

.over {
  flex: 1;
  min-height: 0; /* 关键：允许内容收缩 */
  overflow-y: auto;
  margin-top: 5%;
  padding-right: 5px;
}
.over1 {
  flex: 1;
  min-height: 0; /* 关键：允许内容收缩 */
  overflow-y: auto;
  margin-top: 5%;
  padding-right: 5px;
}


/* 可选：添加滚动条样式 */
.over::-webkit-scrollbar {
  width: 6px;
}
.over::-webkit-scrollbar-thumb {
  background: #c1c1c1;
  border-radius: 3px;
}
  .lessontext {
    font-size: clamp(0.7rem, 0.9vw, 0.9rem);
    padding: clamp(3px, 0.5vh, 8px) clamp(8px, 1vw, 15px);
    min-width: max-content;
    border-radius: 2px;
    background: rgba(245, 245, 245, 1);
    border: 1px solid rgba(217, 217, 217, 1);
    font-size: 14px;
    font-weight: 500;
    letter-spacing: 0px;
    line-height: 20.27px;
    color: rgba(102, 102, 102, 1);
  }
  /* 卡片样式 */
.box1left1, .box1center, .right {
  background: #fff;
  border-radius: 0.625rem;
  padding: 0.9375rem;
}

.box1left1 {
  height: 77vh;
}

.box1center {
  height: 18vh;
  margin-bottom: 2vh;
}
  /* 滚动条美化 */
  ::-webkit-scrollbar {
    width: 6px;
  }
  ::-webkit-scrollbar-thumb {
    background: #c1c1c1;
    border-radius: 3px;
  }
  
  /* 响应式断点优化 */
  @media (max-width: 992px) {
    .mainbox {
      flex-direction: column;
    }
    
    .left-section, .middle-section, .right-section {
      width: 100%;
    }
    
    .motto {
      text-align: center;
      margin-bottom: 10px;
    }
    
    .search-container {
      max-width: 100%;
    }
  }
  
  @media (max-width: 576px) {
    .top {
      flex-direction: column;
      align-items: flex-start;
    }
    
    .top-icons {
      width: 100%;
      justify-content: flex-end;
      margin-top: 10px;
    }
    
    .search-container {
      flex-direction: column;
    }
    
    .search-btn {
      width: 100%;
    }
    

  }
  .right1{
    width: 100%;
    /* height: 70vh; */
    opacity: 1;
      background: #fff;
  border-radius: 0.625rem;
  padding: 0.9375rem;
 

}

.right{
height: 54vh;


border-radius: 10px;
background: rgba(255, 255, 255, 1);
box-shadow: 0px 6px 58px  rgba(196, 203, 214, 0.1);


}
.stu{

/** 文本1 */
font-size: 18px;
font-weight: 500;
letter-spacing: 0px;
line-height: 31.86px;
color: rgba(51, 51, 51, 1);
text-align: left;



  }
    /* 调整Badge位置 */
.item >>> .el-badge__content {
  top: 8px !important;  /* 上移徽标 */
  right: 17px !important;   /* 靠右显示 */
}
.icon{
    font-size: 18px;
    margin: auto;
    margin-right: 10px;
  }
  .icon1{
    font-size: 18px;
    margin: auto;
    margin-right: 20px;
  }
  .butview{

width: 90px;
height: 35px;
opacity: 1;
border-radius: 50px;
background: rgba(39, 154, 255, 0.2);
font-size: 18px;
font-weight: 500;
letter-spacing: 0px;
line-height: 18px;
color: rgba(39, 154, 255, 1);
text-align: center;



 }
 .lessons{

font-size: 18px;
font-weight: 500;
letter-spacing: 0px;
line-height: 31.86px;
color: rgba(51, 51, 51, 1);
margin: auto;
margin-right: 27px;

}
/* 统计卡片容器 - 使用flex布局实现自适应 */
.stats-container {
  display: flex;
  justify-content: space-around;
  flex-wrap: wrap;
  gap: 1.25rem; /* 20px */
  margin-top: 1rem; /* 40px */
}

/* 单个统计卡片样式 */
.stats-card {
  flex: 1;
  min-width: 10rem; /* 200px */
  display: flex;
  align-items: center;
  gap: 1rem; /* 16px */
  padding: 1rem;
  padding-left: 300px;
  border-radius: 0.5rem;

  transition: transform 0.3s ease, box-shadow 0.3s ease;
}

.stats-card:hover {
  transform: translateY(-0.25rem);
  box-shadow: 0 0.25rem 0.75rem rgba(0, 0, 0, 0.15);
}

/* 图标样式 */
.stats-icon {
  width: 3.75rem; /* 60px */
  height: 5rem; /* 80px */
  object-fit: contain;
}

/* 内容区域 */
.stats-content {
  flex: 1;
  min-width: 0;
}

/* 标题样式 */
.stats-title {
  font-size: 1.125rem; /* 18px */
  font-weight: 500;
  line-height: 1.5rem; /* 24px */

  margin-bottom: 0.5rem;
}

/* 数值样式 */
.stats-value {
  font-size: 2.25rem; /* 36px */
  font-weight: 700;
  line-height: 3rem; /* 48px */
  color: #333; /* rgba(51,51,51,1) */
}

/* 响应式设计 */
@media (max-width: 1200px) {
  .stats-card {
    min-width: calc(50% - 0.625rem); /* 两列布局，考虑gap */
  }
}

@media (max-width: 768px) {
  .stats-container {
    gap: 1rem;
  }
  
  .stats-card {
    min-width: 100%; /* 单列布局 */
  }
  
  .stats-icon {
    width: 3rem; /* 48px */
    height: 4rem; /* 64px */
  }
  
  .stats-title {
    font-size: 1rem; /* 16px */
  }
  
  .stats-value {
    font-size: 1.75rem; /* 28px */
    line-height: 2.25rem; /* 36px */
  }
}

@media (max-width: 480px) {
  .stats-card {
    flex-direction: column;
    text-align: center;
    padding: 1.25rem;
  }
  
  .stats-icon {
    width: 2.5rem; /* 40px */
    height: 3.5rem; /* 56px */
    margin-bottom: 0.5rem;
  }
}
.floating-box{
display: flex;
justify-content: end;
position: fixed;     
right: 44px;        
bottom: 20px;        


}
.cur >>> .el-pagination {
  display: flex !important;
  align-items: center !important; /* 垂直居中 */
  gap: 10px !important; /* 元素间距 */
  margin-left: 20px !important;
}

/* 调整页码按钮样式 */
.cur >>> .el-pagination .btn-prev,
.cur >>> .el-pagination .btn-next,
.cur >>> .el-pagination .number {
  margin-top: 0 !important; /* 移除手动 margin */
  vertical-align: middle !important; /* 确保垂直对齐 */
}

/* 调整输入框样式 */
.cur >>> .el-input__inner {
  height: 32px !important;
  line-height: 32px !important;
  margin-top: 0 !important; /* 移除手动 margin */
}

/* 调整跳转文字样式 */
.cur >>> .el-pagination__jump {
  margin-left: 10px !important;
  margin-top: 0 !important;
}
/* 帮扶列表项样式 */
.help-list-item {
  background: #fff;
  border-radius: 8px;
  margin-bottom: 10px;
  transition: all 0.3s ease;
  cursor: pointer;
  padding-bottom: 20px;
}

.help-list-item:hover {
  transform: translateY(-3px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}
.floating-box{
display: flex;
justify-content: end;
position: fixed;     
right: 44px;        
bottom: 20px;        


}
.cur >>> .el-pagination {
  display: flex !important;
  align-items: center !important; /* 垂直居中 */
  gap: 10px !important; /* 元素间距 */
  margin-left: 20px !important;
}

/* 调整页码按钮样式 */
.cur >>> .el-pagination .btn-prev,
.cur >>> .el-pagination .btn-next,
.cur >>> .el-pagination .number {
  margin-top: 0 !important; /* 移除手动 margin */
  vertical-align: middle !important; /* 确保垂直对齐 */
}

/* 调整输入框样式 */
.cur >>> .el-input__inner {
  height: 32px !important;
  line-height: 32px !important;
  margin-top: 0 !important; /* 移除手动 margin */
}

/* 调整跳转文字样式 */
.cur >>> .el-pagination__jump {
  margin-left: 10px !important;
  margin-top: 0 !important;
}
</style>